<template>
  <div class="dialog-container">
    <!-- element-plus -->
    <el-dialog
      center
      title="SN添加"
      v-model="value"
      width="70%"
      @close="handleClose"
      custom-class="dialog-body-style"
    >
      <el-form :inline="true" :model="formData" class="demo-form-inline">
        <div class="form-row">
          <el-form-item label="品牌名称:" prop="prodName">
            <el-select
              v-model="formData.prodName"
              clearable
              placeholder="请选择"
              @change="handlePinp"
            >
              <el-option
                v-for="(item, index) in snOptions.pinP"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类型:" prop="prodType">
            <el-select
              clearable
              v-model="formData.prodType"
              placeholder="请选择"
              @change="handleType"
            >
              <el-option
                v-for="(item, index) in snOptions.type"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号:" prop="prodNo" clearable required>
            <el-select v-model="formData.prodNo" clearable placeholder="请选择">
              <el-option
                v-for="(item, index) in snOptions.num"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item label="维修中心" prop="MaintenanceId" required>
            <el-select
              filterable
              v-model="formData.MaintenanceId"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in snOptions.custormName"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" prop="custormName" required>
            <el-select
              filterable
              v-model="formData.custormName"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in snOptions.custormName"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同号" prop="contractNo">
            <el-input v-model="formData.contractNo"></el-input>
          </el-form-item>
        </div>

        <div class="form-row">
          
          <el-form-item label="是否巡检" prop="State">

            <el-radio-group v-model="formData.State">
              <el-radio :label="true">是 </el-radio>
              <el-radio :label="false"> 否</el-radio>
            </el-radio-group>

            <!-- <el-checkbox v-model="formData.State" size="large" /> -->
          </el-form-item>
          <el-form-item label="" prop=""> </el-form-item>
          <el-form-item label="" prop=""> </el-form-item>
          <el-form-item label="" prop=""> </el-form-item>
          <el-form-item label="" prop=""> </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item label="SN" prop="sn" required style="width:100%; height:150px;">
            <!-- <el-input v-model="formData.sn"></el-input> -->
            <el-input type="textarea" v-model="formData.sn" :rows="5" ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
        <div class="footer-container">
          <el-button type="primary" @click="handleSave">
            保存
          </el-button>
          <el-button type="" @click="handleCencle">
            取消
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, watch, ref, onMounted } from "vue";
import tableApi from "@/api/tabel.js";
import { errMsg, successMsg } from "@/notify/index.js";
export default defineComponent({
  name: "snAdd",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    reloadData: {
      type: Function,
    },
  },
  emits: ["update:value", "reloadData"],

  setup(props, { emit }) {
    const data = reactive({
      formData: {
        prodName: "", //品牌
        prodType: "", //类型
        prodNo: "", //型号
        sn: "", //sn
        custormName: "", //客户名称
        contractNo: "", //合同号
      },
      snOptions: {
        pinP: [],
        type: [],
        num: [],
        custormName: [],
      },
    });
    onMounted(() => {
      methods.getPinP();
      methods.getCustormInfo();
    });
    let methods = {
      handleClose() {
        // const {formData}=data
        // const keys=Object.keys(formData)
        // keys.forEach(item=>{
        //   formData[item]=''
        // })
        data.formData = {State:false};
        emit("update:value", false);
      },
      handleCencle() {
        methods.handleClose();
      },
      async handleSave() {
        const obj = {
          ModelNo_Id: data.formData.prodNo * 1,
          Name: data.formData.sn.split("\n"),
          Company_Id: data.formData.custormName * 1,
          MaintenanceId: data.formData.MaintenanceId,
        };
        const keys = Object.keys(obj);
        const flag = keys.some((item) => {
          return (
            typeof obj[item] == "undefined" ||
            (obj[item] + "").trimStart() == false
          );
        });
        if (flag) {
          errMsg("请输入值");
          return;
        }
        const params = {
          ...obj,
          ContractName: data.formData.contractNo,
          State: data.formData.State,
        };
        const res = await tableApi.addSN(params);
        if (res?.code == 0) {
          successMsg("添加成功");
          methods.handleCencle();
          emit("reloadData");
        } else {
          errMsg(res?.message);
        }
      },
      // 获取品牌信息
      async getPinP() {
        const res = await tableApi.BrandSelect();
        if (res.code == 0) {
          const {
            data: { list },
          } = res;
          data.snOptions.pinP = list.map((item) => ({
            label: item.Name,
            value: item.id,
          }));
        }
        console.log(res, "ressss");
      },
      // 品牌change事件
      async handlePinp(v) {
        data.formData.prodType = "";
        data.formData.prodNo = "";
        const res = await tableApi.ProductSelect({ Bid: v });
        if (res.code == 0) {
          const {
            data: { list },
          } = res;
          data.snOptions.type = list.map((item) => ({
            label: item.Name,
            value: item.id,
          }));
        }
      },
      //  品牌类型change
      async handleType(v) {
        data.formData.prodNo = "";
        const res = await tableApi.modelSelect({ ProductCategoryId: v });
        if (res.code == 0) {
          const {
            data: { list },
          } = res;
          data.snOptions.num = list.map((item) => ({
            label: item.Name,
            value: item.id,
          }));
        }
      },
      // 获取客户信息
      async getCustormInfo() {
        let source = await tableApi.CompanyInfoService();
        if (source.code == 0) {
          const {
            data: { list },
          } = source;
          data.snOptions.custormName = list.map((item) => ({
            label: item.CompName,
            value: item.Company_Id,
          }));
        }
      },
    };

    return {
      ...toRefs(data),
      ...methods,
    };
  },
});
</script>

<style lang="scss" scoped="scoped">
:deep(.el-dialog__body) {
  height: 400px;
}
:deep(.el-form-item__label) {
  font-size: 400;
}
.form-row {
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
}
.footer-container {
  margin-bottom: 50px;

  :deep(.el-button--primary) {
    margin-right: 100px;
  }
}
.el-textarea__inner{
  height:100%
}
</style>
